/**
 * Created by matos on 31/05/2017.
 */
export function AdminSupportChatSystem(options = {}){

	let messengerPlugin = {
		data:{
			box_state: 'closed',
			initial_message: '',
			is_typing_trigger: false,
			is_typing_trigger_timer: null,
			selected_user: '',
			sending_message: false,
			support_active: false,
			support_issue_reference: '',
			support_status: "not_active",
			support_user_active: null,
			support_user_not_responding: false,
			support_users: [],
			update_call: null,
			user_data: {},
			users: {}
		},

		tags:{
			minimized: '.chat_system--tag-minimized',

			new_message: '.chat_system--tag-new_message',

			selected_user: '.chat_system--tag-user_selected',
			selected_support_user: '.chat_system--tag-client_active',

			is_typing: '.chat_system--tag-is_typing',

			new_client: '.chat_system--tag-new_client',
			support_active: '.chat_system--tag-support_active',
			support_user_new_message: '.chat_system--tag-client_message',
			menu_activate_chat: '.chat_system--tag-activate_issue',
			menu_remove_user: '.chat_system--tag-remove_user',
			menu_close_issue: '.chat_system--tag-close_issue',
			menu_state_before: '.chat_system--tag-menu_before',
			menu_state_after: '.chat_system--tag-menu_after',
			not_responding: '.chat_system--tag-not_responding'
		},

		elements:{
			main_box: '.chat_system--box',
			main_box_content: '.chat_system--box-content',
			box_content_messages: '.chat_system--box-content-left-messages',

			small_closed_button:'.chat_system--closed',

			box_close_button: '.chat_system--box-header-right-close_button',
			toggle_support_button: '.chat_system--box-header-right-visible_button',

			send_message_button: '.chat_system--box-content-left-control-send_button',
			message_input: '.chat_system--box-content-left-control-message_input',

			client_control: '.chat_system--box-content-right-client',
			tag_client_content: '.chat_system--box-content-right-client-content',
			tag_client_name: '.chat_system--box-content-right-client-content-name',
			tag_client_actions_menu: '.chat_system--box-content-right-client-content-actions',
			tag_number_in_queue: '.chat_system--box-content-right-client-header-num',
			tag_issue_reference: '.chat_system--box-content-right-client-header-reference',
			tag_prompt_issue_cancel: '.chat_system--box-content-left-messages-message-warn-cancel',
			tag_prompt_issue_close: '.chat_system--box-content-left-messages-message-warn-close',
			tag_prompt_issue_no_save: '.chat_system--box-content-left-messages-message-warn-no_save',

			header: '.chat_system--box-header-left',
			title: '.chat_system--box-header-left-title'

		},

		html_blocks:{
			main_style:
				$(`
					<style type="text/css">
						.chat_system{
							width: 350px;
					
							position:absolute;
							bottom: 10px;
							right: 2%;
						}
						.chat_system--closed{
							text-align: right;
						}
						.chat_system--closed-button{
							padding: 5px;
							margin: 5px;
							background-color: blue;
							color:white;
						}
						.chat_system--box{
							font-family: Helvetica, Arial, sans-serif;
							font-size: 12px;
							border: 1px solid lightgray;
						}
						.chat_system--box-header{
							cursor: pointer;
							width: 100%;
							color: white;
							background-color: blue;
							display: inline-flex;
						}
						.chat_system--box-header-left{
							padding: 10px;
							width: 70%;
							display:inline-block;
						}
						.chat_system--box-header-left-title{
							font-weight: bold;
						}
						.chat_system--box-header-right{
							width: 30%;
							display:inline-block;
							text-align: right;
						}
						.chat_system--box-content{
							background-color: white;
							width: 100%;
							height: 340px;
							overflow: hidden;
							display: inline-flex;
						}
						.chat_system--box-content-left{
							width: 60%;
							height: 100%;
							display: inline-block;
						}
						.chat_system--box-content-left-messages{
							font-family: Helvetica Arial sans-serif;
							font-size: 12px;
							overflow: auto;
							padding: 5px;
							width: 100%;
							height: 90%;
							display: inline-block;
						}
						.chat_system--box-content-left-messages-message-user{
							color: blue;
							font-weight: bold;
						}
						.chat_system--box-content-left-messages-message-warn{
							background-color: lightcoral;
							margin: 1px;
							padding: 10px;
						 }
						.chat_system--box-content-left-control{
							background-color: lightgray;
							width: 100%;
							height: 10%;
							padding: 5px;
						}
						.chat_system--box-content-left-control-message_input{
							width: 70%;
							margin-right: 5px;
						}
						.chat_system--box-content-right{
							background-color: lightsteelblue;
							border-left: 1px solid lightsteelblue;
							overflow: auto;
							height: 100%;
							width: 40%;
							display: inline-block;
						}
						.chat_system--box-content-right-users{
							height: 80%;
						}
						.chat_system--box-content-right-users-user{
							cursor: pointer;
							background-color: lightcyan;
							border-bottom: 1px solid blue;
							width: 100%;
							display: inline-flex;
						}
						.chat_system--box-content-right-users-user.chat_system--tag-new_message{
							background-color: lightgreen !important;
						}
						.chat_system--box-content-right-users-user.chat_system--tag-admin{
							background-color: lightyellow;
						}
						.chat_system--box-content-right-users-user.chat_system--tag-user_selected{
							background-color: lightyellow;
						}
						.chat_system--box-content-right-users-user-name{
							font-size: 10px;
							width: 80%;
						}
						.chat_system--box-content-right-client{
							background-color: #eeeeee;
					
							height: 20%;
							width: 100%;
							padding: 10px;
						}
						.chat_system--box-content-right-client.chat_system--tag-support_active{
							/*background-color: lightcoral;*/
						}
						.chat_system--box-content-right-client.chat_system--tag-new_client{
							 background-color: lightcoral;
						 }
						.chat_system--box-content-right-client.chat_system--tag-client_message{
							background-color: greenyellow !important;
						}
						.chat_system--box-content-right-client.chat_system--tag-client_active{
							background-color: lightyellow;
						}
						.chat_system--box-content-right-users-user-action_buttons{
							width: 20%;
							text-align: center;
						}
					
						.chat_system--tag-button{
							padding: 10px;
							display:inline-block;
						}
					</style>
				`),
			main_block:
				$(`
					<div class="chat_system">
						<div class="chat_system--closed" style="display: none;">
							<span class="chat_system--closed-button glyphicon glyphicon-user"></span>
						</div>
						<div class="chat_system--box" style="display: none;">
							<div class="chat_system--box-header">
								<div class="chat_system--box-header-left">
									<span class="chat_system--box-header-left-title">Chat system</span>
								</div>
								<div class="chat_system--box-header-right">
									<i class="chat_system--box-header-right-visible_button chat_system--tag-button material-icons"></i>
									<i class="chat_system--box-header-right-print_button chat_system--tag-button material-icons">print</i>
									<i class="chat_system--box-header-right-close_button chat_system--tag-button material-icons">close</i>
								</div>
							</div>
							<div class="chat_system--box-content">
								<div class="chat_system--box-content-left">
									<div class="chat_system--box-content-left-messages">
										<!-- This will house all chat messages -->
									</div>
									<div class="chat_system--box-content-left-control">
										<input type="text" class="chat_system--box-content-left-control-message_input" name="chat_system_message" />
										<button class="chat_system--box-content-left-control-send_button">Send</button>
									</div>
								</div>
								<div class="chat_system--box-content-right">
									<div class="chat_system--box-content-right-users">
										<!-- This will house all users -->
									</div>
									<div class="chat_system--box-content-right-client">
										<!-- This is going to be the user controller - controlled by js -->
									</div>
								</div>
							</div>
						</div>
					</div>
				`),
			client_support_control_div:
				$(`
					<div class="chat_system--box-content-right-client-header">
					   <span class="chat_system--box-content-right-client-header-num">0</span>
					   <span> User(s) waiting</span>
					</div>
					<div class="chat_system--box-content-right-client-content dropdown">
					   <span class="chat_system--box-content-right-client-header-reference">ref</span>
					   <span> Issue Reference</span>
					   <br />
					   <span class="chat_system--box-content-right-client-content-name">name of the client</span>
					   <button class="chat_system--tag-actions_button">Actions (dropdown)</button>
					   <div class="chat_system--box-content-right-client-content-actions">
					       <button class="
					           chat_system--tag-menu_before
					           chat_system--tag-activate_issue">Start Conversation</button>
					       <button class="
					           chat_system--tag-menu_before
					           chat_system--tag-remove_user">Remove User</button>
					       <button class="
					           chat_system--tag-menu_after
					           chat_system--tag-close_issue">Close Issue</button>
					   </div>
					</div>
				`),
			message_confirm_exiting:
				$(`
					<div class="chat_system--box-content-left-messages-message">
					   <div class="chat_system--box-content-left-messages-message-warn"> 
					       <span>Are you sure you want to close this issue?</span> 
					       <button class="chat_system--box-content-left-messages-message-warn-close"> 
					           Yes 
					       </button> 
					       <button class="chat_system--box-content-left-messages-message-warn-cancel"> 
					           No 
					       </button> 
					       <button class="chat_system--box-content-left-messages-message-warn-no_save"> 
					           Close without save 
					       </button> 
					   </div> 
					</div>
				`),
			issue_closed:
				$(`
					<div class="chat_system--box-content-left-messages-message"> 
					   <div class="chat_system--box-content-left-messages-message-warn"> 
					       <span>Issue closed</span> 
					   </div> 
					</div>
				`),
			client_is_not_responding:
				$(`
					<div class="chat_system--box-content-left-messages-message"> 
					   <div class=" 
					       chat_system--box-content-left-messages-message-warn 
					       chat_system--tag-not_responding"> 
					       <span>User is not responding...</span> 
					   </div> 
					</div>
				`)
		},

		appendMessage:function (sender, receiver, msg, me = false){

			let
				saving_hash = "";

			me ? saving_hash = receiver.id : saving_hash = sender.id;

			if (this.data.users == null){
				this.data.users = {};
				this.saveData();
			}

			if (this.data.users[saving_hash] == null){
				this.data.users[saving_hash] = [];
			}

			this.data.users[saving_hash].push({
				sender: sender.name,
				receiver: receiver.name,
				message: msg
			});

			this.saveData();

			this.showBox();

			while (msg.indexOf("\n") !== -1)
				msg = msg.replace("\n", "<br />");

			if (this.data.selected_user.id === sender.id || this.data.selected_user.id === receiver.id){
				$(this.tags.is_typing).remove();

				let
					message = '' +
						'<div class="chat_system--box-content-left-messages-message">' +
						'   <span class="chat_system--box-content-left-messages-message-user">' + sender.name + ':</span>' +
						'   <span class="chat_system--box-content-left-messages-message-body">' + msg + '</span> ' +
						'</div>',
					msgObject = $(message);

				$(this.elements.box_content_messages)
					.append(msgObject);

				this.scrollMessagesToBottom();
			}
			else {
				if (this.data.support_status === "in_conversation" &&
					sender.id === this.data.support_user_active.id){
					$(this.elements.client_control).addClass(this.tags.support_user_new_message);
				}
				else {
					$('.chat_system--box-content-right-users-user-name:contains("'+ sender.name +'")')
						.parent()
						.addClass(this.tags.new_message);
				}
			}
		},

		scrollMessagesToBottom:function (){
			$(this.elements.box_content_messages)
				.animate({ scrollTop: $(this.elements.box_content_messages).height() }, 50);
		},


		showBox:function (){
			$(this.elements.small_closed_button).hide();
			$(this.elements.main_box).removeClass("chat_system--tag-minimized").show();
			$(this.elements.main_box_content).show();

			$(this.elements.message_input).focus();

			this.data.box_state = "open";
			this.saveData();
		},
		hideBox:function (){
			$(this.elements.small_closed_button).show();
			$(this.elements.main_box).hide();

			this.data.box_state = "closed";
			this.saveData();
		},
		changeName:function (name){
			$(this.elements.title).html(name);
		},


		closeIssue: function (data){
			this.data.support_status = "closing_issue";
			this.data.support_user_not_responding = false;

			CoreEcho.leave(options.channel + "." + this.data.support_user_active.id);
			this.data.users[this.data.support_user_active.id] = null;
			this.data.support_user_active = this.data.support_issue_reference = null;
			this.data.support_issue_reference = '';

			$(this.elements.client_control)
				.removeClass(this.tags.new_client)
				.removeClass(this.tags.selected_support_user)
				.removeClass(this.tags.support_user_new_message);

			$(this.tags.menu_state_before).show();
			$(this.tags.menu_state_after).hide();

			let messages_html = $(this.elements.box_content_messages).html();

			this.data.support_status = "waiting";

			if (data !== null){
				this.updateSupportList(data.users_in_queue);
			}
			else {
				this.updateSupportList(this.data.support_users);
			}

			this.checkIfSelected();

			$(this.elements.box_content_messages)
				.html(messages_html)
				.append(this.html_blocks.issue_closed);
		},

		setSupportActive:function (){
			window.onbeforeunload = function (e) {
				e = e || window.event;

				if (e) {
					e.returnValue = 'Please deactivate the chat system first';
				}
				return 'Please deactivate the chat system first';
			};

			if (this.data.support_status !== "not_active"){
				return false;
			}

			let _this = this;

			_this.data.support_status = "activating";

			axios.post(options.action, {
				action: "enable_customer_support"
			})
				.then((response) => {
					if (response.data.successful){
						$(_this.elements.toggle_support_button)
							.html("visibility");
						$(_this.elements.client_control)
							.append(_this.html_blocks.client_support_control_div)
							.addClass(_this.tags.support_active);

						if (!response.data.new_insert && _this.data.support_issue_reference !== ''){
							_this.setupSupportChat(_this.data.support_user_active.id);
							_this.data.support_status = "in_conversation";
						}
						else {
							_this.data.support_active = true;
							_this.data.support_status = "waiting";
							_this.data.support_users = response.data.users_in_queue;
						}

						_this.saveData();

						_this.updateSupportList(response.data.users_in_queue);
					}
					else {
						console.error(response.data);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		setSupportInactive:function () {
			window.onbeforeunload = null;

			let _this = this;

			if (_this.data.support_status === "in_conversation"){
				console.error("You can not disable support while in conversation");
				return false;
			}
			else if (_this.data.support_status === "deactivating"){
				return false;
			}

			_this.data.support_status = "deactivating";

			axios.post(options.action, {
				action: "disable_customer_support"
			})
				.then((response) => {
					if (response.data.successful){
						$(_this.elements.toggle_support_button)
							.html("visibility_off");

						$(_this.elements.client_control)
							.html("")
							.removeClass(_this.tags.support_active)
							.removeClass(_this.tags.new_client);


						this.data.support_active = false;
						this.data.support_status = "not_active";
						this.saveData();
					}
					else {
						console.error(response.data);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		newSupportRequestSetup:function (){
			let _this = this;

			if (this.data.support_users.length < 1){
				console.error("New support request setup was called with no support users! data: ", this.data);
				return;
			}
			if (this.data.support_status !== "waiting"){
				console.error("New support request setup was called while not waiting! data: ", this.data);
				return;
			}

			$(this.elements.client_control).addClass(this.tags.new_client);

			$(this.tags.menu_state_before).show();
			$(this.tags.menu_state_after).hide();
			$(this.elements.tag_client_content).show();

			$(this.elements.tag_issue_reference).html(this.data.support_users[0].issue_reference);
			$(this.elements.tag_client_name).html(this.data.support_users[0].user_name);


			//Action Menu

			$(this.tags.menu_activate_chat).click(() => {
				event.preventDefault();
				event.stopPropagation();

				_this.activateChat(_this.data.support_users[0].user_hash);

				return false;
			});

			$(this.tags.menu_remove_user).click(() => {
				event.preventDefault();
				event.stopPropagation();

				_this.removeUserFromChat(
					_this.data.support_users[0].user_hash,
					_this.data.support_users[0].issue_reference
				);

				return false;
			});
		},

		userIsTyping:function (){
			let
				_this = this,
				channel = "";

			if (_this.data.support_status === "in_conversation" &&
				_this.data.selected_user.id === _this.data.support_user_active.id){
				channel =_this.data.selected_user.id;
			}
			else {
				channel = "admin";
			}

			if (!_this.data.is_typing_trigger){
				_this.data.is_typing_trigger = true;

				axios.post(options.action, {
					action: "is_typing",
					user_typing: _this.data.user_data,
					user_in_conversation: _this.data.selected_user,
					channel: channel
				})
					.then(function (response) {
						if (response.data.successful) {

						}
					})
					.catch(function (error){

					});

				_this.data.is_typing_trigger_timer = setInterval(()=>{
					_this.data.is_typing_trigger = false;
					clearInterval(_this.data.is_typing_trigger_timer);

					axios.post(options.action, {
						action: "stop_typing",
						user_typing: _this.data.user_data,
						user_in_conversation: _this.data.selected_user,
						channel: channel
					});
				}, 2000);
			}
			else {
				clearInterval(_this.data.is_typing_trigger_timer);

				_this.data.is_typing_trigger_timer = setInterval(()=>{
					_this.data.is_typing_trigger = false;
					clearInterval(_this.data.is_typing_trigger_timer);

					axios.post(options.action, {
						action: "stop_typing",
						user_typing: _this.data.user_data,
						user_in_conversation: _this.data.selected_user,
						channel: channel
					});
				}, 2000);
			}
		},
		updateUserIsResponding:function (){
			let _this = this;

			if (_this.data.support_user_active &&
				_this.data.selected_user.id === _this.data.support_user_active.id){

				if (_this.data.support_user_not_responding){
					$(_this.elements.box_content_messages).append(
						_this.html_blocks.client_is_not_responding
					);

					this.scrollMessagesToBottom();
				}
				else {
					$(_this.tags.not_responding).parent().remove();
				}
			}
		},

		setupSupportChat:function (user_hash){
			let
				channel = options.channel + '.' + user_hash,
				_this = this;

			CoreEcho.join(channel)
				.here((users) =>{
					if (users.length < 2){
						_this.data.support_user_not_responding = true;
						_this.updateUserIsResponding();
					}
				})
				.joining((user) => {
					if (user.id === user_hash){
						_this.data.support_user_not_responding = false;
						_this.updateUserIsResponding();
					}
				})
				.leaving((user) => {
					if (user.id === user_hash && _this.data.support_status === "in_conversation"){
						_this.data.support_user_not_responding = true;
						_this.updateUserIsResponding();
					}
				})
				.listen('.__alive', function (e) {
					axios.post(e.url, {token: e.token})
				})
				.listen('.' + options.new_message_event, (e) =>{
					if (e.message.receiver.id === _this.data.user_data.id){
						_this.appendMessage(e.message.sender, e.message.receiver, e.message.message);
					}
				})
				.listen('.' + options.user_is_typing, (e) => {
					if ((_this.data.selected_user !== '' || _this.data.support_user_active !== '') &&
						e.user_in_conversation.id === _this.data.user_data.id &&
						e.user_typing.id === _this.data.selected_user.id){
						if (e.is_typing){
							$(_this.elements.header).append(
								'<span class="' + _this.tags.is_typing + '">{...}</span>'
							);
						}
						else {
							$(_this.tags.is_typing).remove();
						}
					}
				})
				.listen('.' + options.close_issue, (e) => {
					//user timed out and issue had to be closed
					_this.closeIssue(null);
				});

			$(_this.tags.menu_state_before).hide();
			$(_this.tags.menu_state_after).show();

			$(_this.elements.tag_issue_reference).html(_this.data.support_issue_reference);
			$(_this.elements.tag_client_name).html(_this.data.support_user_active.name);

			$(_this.tags.new_client).removeClass(_this.tags.new_client);

			$(this.tags.menu_close_issue).click((event) => {
				event.preventDefault();
				event.stopPropagation();

				$(_this.elements.box_content_messages).append(_this.html_blocks.message_confirm_exiting);

				this.scrollMessagesToBottom();

				$(_this.elements.tag_prompt_issue_cancel).click(() => {
					$(_this.elements.tag_prompt_issue_cancel).parent().parent().remove();
				});

				$(_this.elements.tag_prompt_issue_close).click(() => {
					if (_this.data.support_status !== "in_conversation"){
						return false;
					}

					_this.data.support_status = "closing_issue";

					axios.post(options.action, {
						action: "close_issue",
						save: true,
						issue_reference: _this.data.support_issue_reference
					})
						.then(function (response) {
							if (response.data.successful) {
								$(_this.elements.tag_prompt_issue_cancel).parent().parent().remove();
								_this.closeIssue(response.data);
							}
						})
						.catch(function (error){
							console.error(error);
						});
				});

				$(_this.elements.tag_prompt_issue_no_save).click(() => {
					if (_this.data.support_status !== "in_conversation"){
						return false;
					}

					_this.data.support_status = "closing_issue";

					axios.post(options.action, {
						action: "close_issue",
						save: false,
						issue_reference: _this.data.support_issue_reference
					})
						.then(function (response) {
							if (response.data.successful) {
								$(_this.elements.tag_prompt_issue_cancel).parent().parent().remove();
								_this.closeIssue(response.data);
							}
						})
						.catch(function (error){
							console.error(error);
						});
				});

				return false;
			});

			_this.selectUser(_this.data.support_user_active);
		},
		
		activateChat:function (user_hash){
			let _this = this;


			if (this.data.support_status !== "waiting"){
				return false;
			}

			this.data.support_status = "activating_chat";

			axios.post(options.action, {
				action: "start_issue",
				support_user_id: this.data.user_data.id,
				user_id: user_hash,
				issue_reference: this.data.support_users[0].issue_reference
			})
				.then(function (response) {
					if (response.data.successful){
						_this.data.support_issue_reference = _this.data.support_users[0].issue_reference;
						_this.data.support_status = "in_conversation";
						_this.data.support_user_active = {
							id: _this.data.support_users[0].user_hash,
							name: _this.data.support_users[0].user_name,
							email: _this.data.support_users[0].user_email
						};

						_this.setupSupportChat(user_hash);

						_this.updateSupportList(response.data.users_in_queue);

						//Sending the initial message
						_this.sendMessage(
							_this.data.user_data,
							_this.data.support_user_active,
							_this.data.initial_message,
							_this.data.support_user_active.id);
					}
				})
				.catch(function (error){
					console.error(error);
				});
		},
		removeUserFromChat:function (user_hash, issue_reference) {
			let _this = this;

			if (_this.data.support_status !== "waiting"){
				return true;
			}

			_this.data.support_status = "removing_user";

			axios.post(options.action, {
				action: "cancel_customer_request",
				issue_reference: issue_reference,
				id: user_hash
			})
				.then(function (response) {
					if (response.data.successful) {
						_this.data.support_status = "waiting";
						_this.updateSupportList(response.data.users_in_queue);
					}
				})
				.catch(function (error){
					console.error(error);
				});
		},

		updateSupportList:function (users){
			this.data.support_users = users;
			this.saveData();

			if (!this.data.support_active){
				return false;
			}

			$(this.elements.tag_number_in_queue).html(this.data.support_users.length);

			if (this.data.support_status === "waiting"){
				if (this.data.support_users.length > 0){
					this.newSupportRequestSetup();
				}
				else {
					$(this.elements.client_control).removeClass(this.tags.new_client);
					$(this.elements.tag_client_content).hide();
				}
			}
		},


		readInitialData:function (){
			this.readData();

			this.data.sending_message = false;

			switch (this.data.box_state){
				case "closed":
					this.hideBox();
					break;
				case "minimized":
					this.showBox();
					this.toggleBox();
					break;
				case "open":
					this.showBox();
					break;
			}

			if (this.data.selected_user !== ""){
				if ($('.chat_system--box-content-right-users-user-name:contains("'+ this.data.selected_user +'")').length > 0){
					this.selectUser(this.data.selected_user);
				}
			}

			if (this.data.support_active){
				this.data.support_status = "not_active";
				this.setSupportActive();
			}
			else {
				this.setSupportInactive();
			}
		},

		readData:function (){
			let data = sessionStorage.getItem(options.local_storage_item);

			if (data){
				this.data = JSON.parse(data);
			}
		},

		saveData:function (){
			let json_data = JSON.stringify(this.data);
			sessionStorage.setItem(options.local_storage_item, json_data);
		},



		selectUser:function (usr){
			$(`.chat_system--tag-user_selected`).removeClass(this.tags.selected_user);
			$(`.chat_system--tag-client_active`).removeClass(this.tags.selected_support_user);

			if (this.data.support_user_active && usr.id === this.data.support_user_active.id){
				$(this.elements.client_control)
					.addClass(this.tags.selected_support_user)
					.removeClass(this.tags.support_user_new_message);
			}
			else {
				$('.chat_system--box-content-right-users-user-name:contains("'+ usr.name +'")')
					.parent()
					.addClass(this.tags.selected_user)
					.removeClass('chat_system--tag-new_message');
			}

			$(this.tags.is_typing).remove();
			this.data.selected_user = usr;
			this.saveData();
			this.checkIfSelected();

			if (this.data.users == null){
				this.data.users = {};
				this.saveData();
			}

			if (this.data.users[usr.id] !== null){
				$.each(this.data.users[usr.id], (i, msg) => {
					while (msg.message.indexOf("\n") !== -1){
						msg.message = msg.message.replace("\n", "<br />");
					}

					let
						message = '' +
							'<div class="chat_system--box-content-left-messages-message">' +
							'   <span class="chat_system--box-content-left-messages-message-user">' + msg.sender + ':</span>' +
							'   <span class="chat_system--box-content-left-messages-message-body">' + msg.message + '</span> ' +
							'</div>',
						msgObject = $(message);

					$(`.chat_system--box-content-left-messages`).append(msgObject);
				});
			}

			this.updateUserIsResponding();
			this.changeName(usr.name);
		},

		checkIfSelected:function (){
			//Checks if any user is selected, else disable the input and control
			$(this.elements.box_content_messages).html("");

			if ($(this.tags.selected_user).length <= 0 &&
				$(this.tags.selected_support_user).length <=0){

				this.data.selected_user = "";
				this.saveData();

				$(this.elements.send_message_button).prop("disabled", true);
				$(this.elements.message_input).prop("disabled", true);

				this.changeName("(select a user)");
			}
			else {
				$(this.elements.send_message_button).prop("disabled", false);
				$(this.elements.message_input).prop("disabled", false);
			}
		},

		appendUser:function (usr){
			let user_block = '' +
				'<div class="chat_system--box-content-right-users-user">' +
				'   <span class="chat_system--box-content-right-users-user-name">' + usr.name + ' (' + usr.email + ')</span>' +
				'</div>',
				userObject = $(user_block),
				_this = this;

			userObject.click(() => {
				_this.selectUser(usr);
			});

			$(`.chat_system--box-content-right-users`).append(userObject);
		},

		removeUser:function (usr){
			let userObject = $('.chat_system--box-content-right-users-user-name:contains("'+ usr.name +'")').parent();

			if (userObject.hasClass('chat_system--tag-user_selected')){

			}

			userObject.remove();
		},



		updateCall:function (){
			let _this = this;

			axios.post(options.request_data, {
				request: 'get_data'
			})
				.then(function (response) {
					if (response.data.successful){
						//carry on brother
					}
					else {
						//ops... somehow it timeout
						$(`.chat_system`).remove();
						sessionStorage.setItem(options.local_storage_item, '');

						console.error("Something went worng with the chat system");
					}
				})
				.catch(function (error){
					$(`.chat_system`).remove();

					window.clearInterval(_this.data.update_call);
					sessionStorage.setItem(options.local_storage_item, '');

					console.error("Something went worng with the chat system");

					console.error(error);
				});
		},



		sendMessage:function (sender, receiver, msg, channel){
			let _this = this;

			//if the message is not empty
			if (msg.trim().length >= 1){
				if (_this.data.sending_message){
					return false;
				}

				_this.data.sending_message = true;
				$(_this.elements.message_input).val(""); //clear the input

				let data = {
					action: "send_message",
					sender: sender,
					receiver: receiver,
					channel: channel,
					message: msg
				};

				if (this.data.support_status === "in_conversation" &&
					receiver.id === this.data.support_user_active.id){
					data.issue_reference = this.data.support_issue_reference;
				}

				//let's make the call to send the message
				axios.post(options.action, data)
					.then(function (response) {
						if (response.data.successful){
							_this.appendMessage(sender, receiver, msg, true);
							_this.data.sending_message = false;
						}
					})
					.catch(function (error){
						console.error(error);
					});
			}
		},


		setup:function (data){
			let
				_this = this,
				channel = options.channel + ".admin";
			this.data.initial_message = data.initial_message;

			CoreEcho.join(channel)
				.here((users) =>{
					$.each(users, (i, user) => {
						if (user.id !== data.user_hash){
							_this.appendUser(user);
						}
					});

					_this.readInitialData();

					if (!_this.data.user_data.id){
						_this.data.user_data = {
							id: data.user_hash,
							email: data.user_email,
							name: data.user_name
						};
						_this.saveData();
					}
					_this.checkIfSelected();
				})
				.joining((user) => {
					_this.appendUser(user);
				})
				.leaving((user) => {
					_this.removeUser(user);
					_this.checkIfSelected();
				})
				.listen('.__alive', function (e) {
					axios.post(e.url, {token: e.token})
				})
				.listen('.' + options.new_message_event, (e) =>{
					if (e.message.receiver.id === _this.data.user_data.id){
						_this.appendMessage(e.message.sender, e.message.receiver, e.message.message);
					}
				})
				.listen('.' + options.update_support_event, (e) => {
					this.updateSupportList(e.users_in_queue);
				})
				.listen('.' + options.user_is_typing, (e) => {
					if ((_this.data.selected_user !== '') &&
						e.user_in_conversation.id === _this.data.user_data.id &&
						e.user_typing.id === _this.data.selected_user.id){
						if (e.is_typing){
							$(_this.elements).header.append(
								'<span class="' + _this.tags.is_typing + '">{...}</span>'
							);
						}
						else {
							$(_this.tags.is_typing).remove();
						}
					}
				});

			//control handle

			//send message button
			$(_this.elements.send_message_button).click(function (){
				let
					sender = {
						id: data.user_hash,
						name: data.user_name,
						email: data.user_email
					},
					receiver =  _this.data.selected_user,
					channel = "admin",
					msg = _this.elements.message_input.val(); //grabbing the message

				if (_this.data.support_status === "in_conversation"
					&& receiver.id === _this.data.support_user_active.id){
					channel = receiver.id;
				}

				_this.sendMessage(sender, receiver, msg, channel);
			});
			//if the user presses control + enter on the chat box will send the message
			$(_this.elements.message_input)
				.keyup((event) => {
					if(event.keyCode === 13 && event.ctrlKey){
						$(_this.elements.send_message_button).click();
					}
				})
				.on('input propertychange', () => {
					_this.userIsTyping();
				});


			//header handle

			//close chat / hide chat
			$(_this.elements.box_close_button).on('click', (event) => {
				_this.hideBox();
			});

			//toggle support
			$(_this.elements.toggle_support_button).on('click', (event) => {
				if (_this.data.support_active){
					_this.setSupportInactive();
				}
				else {
					_this.setSupportActive();
				}
			});


			//small button click
			$(_this.elements.small_closed_button).click(() => {
				_this.showBox();
			});

			//Support control
			$(_this.elements.client_control).click(() => {
				if (_this.data.support_status === 'in_conversation'){
					_this.selectUser(_this.data.support_user_active);
				}
			});

			//Setting up a timer for update call
			_this.data.update_call = window.setInterval(function (){
				_this.updateCall();
			}, options.update_me_timeout * 1000);
		},

		init:function (options){
			let
				_this = this,
				public_functionality = {
					show: function () {
						_this.showBox();
					},
					hide: function (){
						_this.hideBox();
					},
					title: function (name){
						_this.changeName(name);
					},
					__getData:function(){
						return _this.data;
					}
				};

			//putting the block in the DOM
			$(document.body)
				.append(_this.html_blocks.main_style)
				.append(_this.html_blocks.main_block);

			window.testing_style = _this.html_blocks.main_style;
			window.testing_block = _this.html_blocks.main_block;

			//Checking if the user is authenticated and grabbing all necessary data

			axios.post(options.request_data, {
				request: "get_data"
			})
				.then((response) => {
					if (response.data.successful){
						_this.setup(response.data);
					}
					else {
						//User is not valid
						$(`.chat_system`).remove();
					}
				})
				.catch((error) => {
					//User is not valid
					console.warn(error);
					$(`.chat_system`).remove();

					sessionStorage.setItem(options.local_storage_item, '');

					return null;
				});

			return public_functionality;
		}
	};

	return messengerPlugin.init(options);
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/notifications/AdminSupportChatSystem.js